import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TabContainerContent } from './TabContainerContent'
import { useGetTabContainer } from './useGetTabContainer'
import { TileFilter } from '../shared/TileFilter'

export const TabContainerComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetTabContainer(id, tileFilterSelections)

  return (
    <TabContainerContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function TabContainerComponentLoading() {
  return 'Loading...'
}
